import Icon from '@/components/ui/AppIcon';

interface SearchBarProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  resultsCount: number;
}

export default function SearchBar({ searchQuery, onSearchChange, resultsCount }: SearchBarProps) {
  return (
    <div className="bg-card rounded-lg shadow-organic-sm p-6 border border-border">
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
          <Icon name="MagnifyingGlassIcon" size={20} variant="outline" className="text-muted-foreground" />
        </div>
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search news articles..."
          className="w-full pl-12 pr-4 py-3 bg-background border border-input rounded-md text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring font-body"
        />
      </div>
      {searchQuery && (
        <div className="mt-3 text-sm text-muted-foreground font-body">
          Found {resultsCount} {resultsCount === 1 ? 'article' : 'articles'} matching "{searchQuery}"
        </div>
      )}
    </div>
  );
}